// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".settlement-details-transaction-list{margin-top:60px}", "",{"version":3,"sources":["webpack://./src/settlements/containers/settlementTransactionByEmidContainer.scss"],"names":[],"mappings":"AAAA,qCACI,eAAA","sourcesContent":[".settlement-details-transaction-list{\n    margin-top: 60px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
